<script setup>
import { useMsgStore } from '@/store/msgStore'
import router from '@/router'
const msgStore = useMsgStore()
const item_list = msgStore.totalPages.home1.items

const on_item_click = (item) => {
  if (item.path && item.name) {
    router.push(`${item.path}?name=${item.name}`)
  } else if(item.url) {
    window.open(item.url)
  }
}
</script>

<template>
  <v-sheet height="100vh" theme="dark" style="pointer-events: none;">
    <v-img class="fill-height" src="images/home_1.png" cover>
      <v-fade-transition>
        <div class="d-flex align-end justify-space-between h-100">
          <v-card class="text-start pa-16 h-100" variant="text">
            <v-card-item class="mt-16">
              <div class="text-h2 font-weight-black">
                小林通的星球计划
              </div>
            </v-card-item>
            <v-divider class="ma-2" :thickness="3"></v-divider>
            <v-card-subtitle class="mt-2">
              这里记录了我的异想天开和奇思妙想，还有一些奇奇怪怪的脑洞。
            </v-card-subtitle>
            <v-card-subtitle class="mt-2">
              一些乱七八糟的杂谈，希望能够给你带来启发和帮助。
            </v-card-subtitle>

            <div style="height: 30px;"></div>
            <v-card class="mt-3" v-for="item, index in item_list" style="pointer-events: auto;" :key="index"
              variant="text">
              <v-chip class="font-weight-bold text-h6" height="48" rounded="xl" variant="text">
                {{ item.name }}
              </v-chip>
              <div class="d-flex ma-2 mt-3 ms-4 text-body-2">
                <v-chip v-for="e, i in item.items" :key="i" @click="on_item_click(e)" variant="text">
                  {{ e.name }}
                </v-chip>
              </div>
            </v-card>
          </v-card>
          <v-card class="mb-8 text-center" width="180" variant="text">
            <v-card-text class="text-body-1">向下滑动</v-card-text>
            <v-icon class="mb-4">mdi-chevron-triple-down</v-icon>
          </v-card>
        </div>
      </v-fade-transition>
    </v-img>
  </v-sheet>
  <v-sheet>
    <div class="d-flex flex-wrap">
      <div v-for="item, index in item_list" :key="index" class="w-100">
        <v-card class="d-flex justify-space-between" :class="index % 2 ? 'flex-row-reverse' : ''"
          :color="index % 2 ? '#000' : '#FFF'">
          <v-card class="ma-4" variant="text" @click="on_item_click(item)">
            <v-img rounded="lg" :src="item.thumbnail" :aspect-ratio="16 / 9" width="50vw" cover>
            </v-img>
          </v-card>
          <v-card-item class="text-center">
            <v-card-title class="text-h4 mb-4">
              {{ item.name }}
            </v-card-title>
            <v-card-subtitle>
              {{ item.desc }}
            </v-card-subtitle>
            <v-card-item>
              <v-btn class="mx-2 rounded-pill font-weight-bold" size="large" v-for="e, i in item.items" :key="i"
                :color="index % 2 ? '#FFF' : '#000'" @click.stop="on_item_click(e)">
                {{ e.name }}
              </v-btn>
            </v-card-item>
          </v-card-item>
        </v-card>
      </div>
    </div>
  </v-sheet>
</template>